import React from 'react'
import './style.scss';

const TitleExpand = ({title,color}) => {
  return (
    <p className="title-expand" style={{color:`var(${color})`}}>{title}</p>
  )
}

export default TitleExpand